import React, { Suspense } from "react";
import PdfViewer from "./PdfViewer";

// Lazy load para não pesar o bundle inicial se não tiver DOCX
const DocxViewer = React.lazy(() => import("./DocxViewer"));

const getExt = (url = "") => {
  try {
    const clean = url.split("?")[0].split("#")[0];
    return clean.slice(clean.lastIndexOf(".") + 1).toLowerCase();
  } catch { return ""; }
};

const FileViewer = ({ url, height = "600px", preferOfficeEmbed = false }) => {
  const ext = getExt(url);

  if (ext === "pdf") {
    return <PdfViewer url={url} height={height} />;
  }

  if (ext === "docx") {
    if (preferOfficeEmbed) {
      const officeSrc = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`;
      return (
        <iframe 
          title="DOCX Viewer" 
          src={officeSrc} 
          style={{ width: "100%", height: height, border: "1px solid #ccc" }} 
        />
      );
    }
    
    return (
      <Suspense fallback={<div style={{ padding: 20, textAlign: 'center' }}>Carregando visualizador...</div>}>
        <DocxViewer url={url} height={height} />
      </Suspense>
    );
  }

  // Imagens
  if (["png", "jpg", "jpeg", "gif", "webp", "bmp"].includes(ext)) {
    return (
      <div style={{ border: "1px solid #ccc", height: height, overflow: "auto", display: 'flex', justifyContent: 'center', background: '#f9f9f9' }}>
        <img src={url} alt="Visualização" style={{ maxWidth: "100%", height: "auto", objectFit: "contain" }} />
      </div>
    );
  }

  // Fallback
  return (
    <div style={{ border: "1px solid #ccc", padding: 20, height: height, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
      <p>Visualização não disponível para <b>.{ext}</b></p>
      <a href={url} target="_blank" rel="noreferrer" style={{color: '#007bff', fontWeight: 'bold'}}>
        Baixar Arquivo
      </a>
    </div>
  );
};

export default FileViewer;